export default {
  getBillFromNotPaidBills(state) {
    return (id) => state.notPaidBills.find((bill) => parseInt(bill.id, 10) === id);
  },
  translatedPaymentMethod(state) {
    const { currentBilling } = state;

    if (currentBilling.recurrent_payment_method === 'boleto') return 'boleto';
    if (currentBilling.recurrent_payment_method === 'credit_card') return 'cartão de crédito';
    if (currentBilling.recurrent_payment_method === 'pix') return 'pix';
    return 'cartão de débito';
  },
  showContractDischarge(state) {
    const { currentBilling, currentContract } = state;
    return currentContract
      && currentBilling.origin !== 'from_parcelamento'
      && currentContract.status !== 'finished'
      && currentBilling.institution_id !== 493
      && currentBilling.contract_discharge_payment_types
      && currentBilling.contract_discharge_payment_types.length;
  },
  creditCardEnabled(state) {
    const { currentBilling } = state;
    return currentBilling.institution_id !== 493;
  },
  permittedPaymentMethods(state) {
    return state.currentBilling.payment_methods;
  },
};
